import { useState, useEffect, useRef } from "react";

const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

/**
 * Anima de lastSeen → target SOMENTE quando isActive vira true.
 * Enquanto inativo, mantém o display no último valor que o usuário viu.
 */
const useTabCountUp = (target, isActive, duration = 700) => {
  const lastSeenRef = useRef(target); // valor que o usuário viu por último
  const [display, setDisplay]   = useState(target);
  const rafRef = useRef(null);

  // Quando a aba fica ativa: anima lastSeen → target
  useEffect(() => {
    if (!isActive) {
      // Inativo: mantém display no lastSeen (usuário não está vendo)
      setDisplay(lastSeenRef.current);
      return;
    }

    const from = lastSeenRef.current;
    const to   = target;

    if (from === to) { setDisplay(to); return; }

    cancelAnimationFrame(rafRef.current);
    let startTime = null;

    const step = (ts) => {
      if (!startTime) startTime = ts;
      const p = Math.min((ts - startTime) / duration, 1);
      setDisplay(Math.round(from + (to - from) * easeOutCubic(p)));
      if (p < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        lastSeenRef.current = to; // só atualiza lastSeen ao terminar
      }
    };

    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [target, isActive]); // eslint-disable-line

  return display;
};

export default useTabCountUp;